import type React from 'react'
import type { ReactElement } from 'react'

export function IconStake(props: React.SVGProps<SVGSVGElement>): ReactElement {
  return (
    <svg width={66} height={55} viewBox={'0 0 66 55'} fill={'none'} xmlns={'http://www.w3.org/2000/svg'} {...props}>
      <path
        d={
          'M31.9393 38.0607C32.5251 38.6464 33.4749 38.6464 34.0607 38.0607L43.6066 28.5147C44.1924 27.9289 44.1924 26.9792 43.6066 26.3934C43.0208 25.8076 42.0711 25.8076 41.4853 26.3934L33 34.8787L24.5147 26.3934C23.9289 25.8076 22.9792 25.8076 22.3934 26.3934C21.8076 26.9792 21.8076 27.9289 22.3934 28.5147L31.9393 38.0607ZM33 0L31.5 0L31.5 37H33H34.5V0L33 0Z'
        }
        fill={'currentColor'}
      />
      <path
        d={
          'M54 17C57.3137 17 60 19.6863 60 23V44L59.9922 44.3086C59.8367 47.3767 57.3767 49.8367 54.3086 49.9922L54 50H12L11.6914 49.9922C8.62332 49.8367 6.16325 47.3767 6.00781 44.3086L6 44V23C6 19.6863 8.68629 17 12 17H25V20H12C10.3431 20 9 21.3431 9 23V44C9 45.6569 10.3431 47 12 47H54C55.6569 47 57 45.6569 57 44V23C57 21.3431 55.6569 20 54 20H40V17H54Z'
        }
        fill={'currentColor'}
      />
      <path
        d={
          'M55.5664 11.0146C61.3783 11.3094 66 16.1148 66 22V44C66 49.8852 61.3783 54.6906 55.5664 54.9854L55 55H11C4.92487 55 0 50.0751 0 44V22C0 15.9249 4.92487 11 11 11H19V14H11C6.58172 14 3 17.5817 3 22V44C3 48.4183 6.58172 52 11 52H55C59.4183 52 63 48.4183 63 44V22C63 17.5817 59.4183 14 55 14H47V11H55L55.5664 11.0146Z'
        }
        fill={'currentColor'}
      />
    </svg>
  )
}
